import { isPlainObject } from "lodash-es";
import { getDeviceId, getDecodedTime } from "./helpers";

export function getDemoTextMessages(demoMessages) {
  if (!Array.isArray(demoMessages)) throw new Error(`Expected array of messages`);
  const textMessages = {};
  let total = 0;
  for (const msg of demoMessages) {
    if (!msg.name?.startsWith('text') || !isPlainObject(msg.payload)) continue;
    const { payload } = msg;
    const deviceId = msg.deviceId || getDeviceId(payload);
    if (!deviceId) continue;
    if (msg.name && msg.name.startsWith('text')) {
      const textData = { ...payload };
      textData.time = getDecodedTime(msg);
      textData.sender = msg.direction === 'UPLINK'
        ? msg.deviceId
        : (payload.source || 'DISPATCH');
      if (!(deviceId in textMessages)) {
        textMessages[deviceId] = [];
      }
      textMessages[deviceId].push(textData);
      total++;
    }
  }
  for (const deviceId in textMessages) {
    textMessages[deviceId].sort((a, b) => a.time.localeCompare(b.time));
  }
  return { textMessages, total };
}
